import FooterBlock from "../../components/Footer/Footer";
import GameSetsLoggedInView from "./components/GameSetsLoggedInView";
import LoggedOutView from "../LoggedOutPage/LoggedOutPage";
import { User } from "../../models/user";

interface GameSetsPageProps {
  loggedInUser: User | null;
}

const GameSetsPage = ({ loggedInUser }: GameSetsPageProps) => {
  return (
    <div className="startBellowNavbar pageBlock">
      {loggedInUser ? (
        <>
          <GameSetsLoggedInView />
          <FooterBlock />
        </>
      ) : (
        <LoggedOutView />
      )}
    </div>
  );
};

export default GameSetsPage;
